import type {AosOptions} from 'aos';

let isAosReady = false;

const getAos = async () => {
    const [{default: AOS}] = await Promise.all([
        import('aos'),
        import('aos/dist/aos.css'),
    ]);

    return AOS;
};

export const initAos = async (params: AosOptions = {}) => {
    if (import.meta.server) {
        return;
    }

    const AOS = await getAos();
    const shouldReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    AOS.init({
        disable: shouldReduceMotion,
        ...params,
    });

    isAosReady = true;

    window.addEventListener('load', () => AOS.refresh());
};

export const refreshAos = async ({resetFooter = false}: {resetFooter?: boolean} = {}) => {
    if (import.meta.server || !isAosReady) {
        return;
    }

    const AOS = await getAos();

    if (resetFooter) {
        document
            .querySelectorAll<HTMLElement>('.footer [data-aos]')
            .forEach((element) => element.classList.remove('aos-animate'));
    }

    window.requestAnimationFrame(() => {
        AOS.refreshHard();
    });
};
